var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightMember(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11845_69804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 4.25C11.2735 4.25 12.0154 4.55729 12.5624 5.10427C13.1094 5.65125 13.4167 6.39312 13.4167 7.16667C13.4167 7.94022 13.1094 8.68208 12.5624 9.22906C12.0154 9.77604 11.2735 10.0833 10.5 10.0833C9.72645 10.0833 8.98459 9.77604 8.43761 9.22906C7.89062 8.68208 7.58333 7.94022 7.58333 7.16667C7.58333 6.39312 7.89062 5.65125 8.43761 5.10427C8.98459 4.55729 9.72645 4.25 10.5 4.25ZM4.66667 6.33333C5.13333 6.33333 5.56667 6.45833 5.94167 6.68333C5.81667 7.875 6.16667 9.05833 6.88333 9.98333C6.46667 10.7833 5.63333 11.3333 4.66667 11.3333C4.00363 11.3333 3.36774 11.0699 2.8989 10.6011C2.43006 10.1323 2.16667 9.49638 2.16667 8.83333C2.16667 8.17029 2.43006 7.53441 2.8989 7.06557C3.36774 6.59673 4.00363 6.33333 4.66667 6.33333ZM16.3333 6.33333C16.9964 6.33333 17.6323 6.59673 18.1011 7.06557C18.5699 7.53441 18.8333 8.17029 18.8333 8.83333C18.8333 9.49638 18.5699 10.1323 18.1011 10.6011C17.6323 11.0699 16.9964 11.3333 16.3333 11.3333C15.3667 11.3333 14.5333 10.7833 14.1167 9.98333C14.8429 9.04519 15.1801 7.86347 15.0583 6.68333C15.4333 6.45833 15.8667 6.33333 16.3333 6.33333ZM5.08333 14.875C5.08333 13.15 7.50833 11.75 10.5 11.75C13.4917 11.75 15.9167 13.15 15.9167 14.875V16.3333H5.08333V14.875ZM0.5 16.3333V15.0833C0.5 13.925 2.075 12.95 4.20833 12.6667C3.71667 13.2333 3.41667 14.0167 3.41667 14.875V16.3333H0.5ZM20.5 16.3333H17.5833V14.875C17.5833 14.0167 17.2833 13.2333 16.7917 12.6667C18.925 12.95 20.5 13.925 20.5 15.0833V16.3333Z",
    fill: "#595959"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11845_69804"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightMember);
export default __webpack_public_path__ + "static/media/light_member.1d7f2cd197047879fde386b62de1ec4a.svg";
export { ForwardRef as ReactComponent };